// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__l8zGL","col":"styles_col__1zMI8"};